// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,
  authSettings: {
    clientId: '39ef8dff-25a2-4ed8-a8be-cbc979b56938',
    tenant: 'honidentitydev.onmicrosoft.com',
    expireOffsetSeconds: 3000,
    endpoints: {
      'https://devintegrated.azure-api.net/portal/v1/api/': 'https://honidentitydev.onmicrosoft.com/integrated-allegrettoapi/'
    },
    ocpApimSubscriptionKey: '77eeecd7470c4b3fbddb0eab84ed85fe',
    organizationId: '',
    getRoleUrl: 'https://devintegrated.azure-api.net/portal/v1/api/User/RolesAndPrivileges/',
    getRoleResource: 'https://honidentitydev.onmicrosoft.com/integrated-allegrettoapi/',
  },
  orgSettingsApiUrl: 'https://devintegrated.azure-api.net/portal/v1/api/Settings',
  orgPresalesSettingsApiUrl: 'https://devintegrated.azure-api.net/portal/v1/api/PresalesSettings',
  fileUploadUrl: 'https://devintegrated.azure-api.net/portal/v1/api/file/upload',
  fileContentUrl: 'https://devintegrated.azure-api.net/portal/v1/api/file/content',
  ocpApimSubscriptionKey: 'dbc84e991a3b4b8aa19a4f704202a139',
  dmsPortalUrl: 'https://honeywellprod.sharepoint.com/teams/OBS-DMS/SitePages/Home.aspx',
  CORToolUrl: 'https://honeywellprod.sharepoint.com/:f:/r/teams/OBS-DMS/OBS%20Project%20Files/ProcessDocuments%26Tools/EBI%20-%20OBS%20Site%20Information%20Gathering%20Tool',
  gatewayTenantAccountApiUrl: 'https://fc.qa.api.gatewaymgr.honeywell.com/api/tenants',
  gatewayManagerAPIKongAuthKey: 'Io3TfT3O0Nf3MIZUL5H6R8CfVznmK7oy',
  cdt: {
    api_url: 'https://portalsit.dev.honeywellcloud.com/modeleditorapi/',
    ttl: 15,
    refreshInterval: 25000
  },
  historyValidation: {
    historyValidationServiceUrl: 'https://devintegrated.azure-api.net/portal/v1/api/history-validation/',
    historyValidationOcpApimSubscriptionKey: '77eeecd7470c4b3fbddb0eab84ed85fe'
  },
  eventLogger: {
    api_url: 'https://qa-cbld-adminportal-onboardingworkflowservice.dev.honeywellcloud.com/api/'
  },
  launchDarklyClientId: '58f89a9f5a64a10a1bc8aae0',
  launchDarklyUserKey: 'sdk-24186864-b967-4b17-b156-80cbcc9cd91d'
};
